/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BasePartyViewModel } from './BasePartyViewModel';
import {
    BasePartyViewModelFromJSON,
    BasePartyViewModelFromJSONTyped,
    BasePartyViewModelToJSON,
} from './BasePartyViewModel';

/**
 * 
 * @export
 * @interface ClientDetailsResponseViewModel
 */
export interface ClientDetailsResponseViewModel {
    /**
     * 
     * @type {number}
     * @memberof ClientDetailsResponseViewModel
     */
    proposalId?: number;
    /**
     * 
     * @type {Array<BasePartyViewModel>}
     * @memberof ClientDetailsResponseViewModel
     */
    duplicates?: Array<BasePartyViewModel>;
}

/**
 * Check if a given object implements the ClientDetailsResponseViewModel interface.
 */
export function instanceOfClientDetailsResponseViewModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ClientDetailsResponseViewModelFromJSON(json: any): ClientDetailsResponseViewModel {
    return ClientDetailsResponseViewModelFromJSONTyped(json, false);
}

export function ClientDetailsResponseViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientDetailsResponseViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'proposalId': !exists(json, 'ProposalId') ? undefined : json['ProposalId'],
        'duplicates': !exists(json, 'Duplicates') ? undefined : ((json['Duplicates'] as Array<any>).map(BasePartyViewModelFromJSON)),
    };
}

export function ClientDetailsResponseViewModelToJSON(value?: ClientDetailsResponseViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ProposalId': value.proposalId,
        'Duplicates': value.duplicates === undefined ? undefined : ((value.duplicates as Array<any>).map(BasePartyViewModelToJSON)),
    };
}

